<div class="notification-to-front-items-needed-main ui-dark-background" data-cy="items-needed-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="items-needed-header-section">
      <div class="section-header-title" data-cy="items-needed-title-text">
        Items Needed
      </div>
      <div style="flex: 1;"></div>
    </div>
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column;" data-cy="items-needed-content-section">
      <!--<div style="flex: 1; display: flex; flex-direction: column; max-height: 100%; overflow-y: hidden;">

    </div>-->
    <div style="display: flex; flex-basis: 30px; margin-bottom: 1px; background-color: var(--tdo-background); padding: 6px 6px 0 6px;" data-cy="items-needed-letters-header">
      <div style="flex: 1; font-weight: 500; color: var(--tdo-primary);" data-cy="items-needed-letters-title">Letters to Send</div>
      <div style="flex-basis: 30px; cursor: pointer; color: var(--tdo-primary-accent);" (click)="onAddLetterClick()" matTooltip="Add letters template" data-cy="items-needed-add-letter-button"><lucide-icon name="plus-circle" [size]="20"></lucide-icon></div>
    </div>
    <div style="flex: 1; margin-bottom: 3px; background-color: var(--tdo-background); border-radius: var(--border-radius); max-height: 100%; overflow-y: hidden;" data-cy="items-needed-letters-container">
      <div style="height: 100%; width: 100%; overflow-y: hidden; padding: 6px; max-height: 100%;" data-cy="items-needed-letters-table-container">
        @if (notificationNeededModel && notificationNeededModel.dataNotificationNeededItems) {
          <tdo-table #tdoTable [dataSource]="notificationNeededModel.dataNotificationNeededItems" [isSearchable]="false" data-cy="items-needed-letters-table">
            <tdo-table-column [rowTemplate]="sendTo" propertyName="ToContactID" displayName="Send To">
              <ng-template #sendTo let-row>
                <div style="display: flex;" data-cy="items-needed-sendto-cell">
                  <div style="flex-basis: 60px;" data-cy="items-needed-delivery-role">{{getDeliveryRole(row)}}</div>
                  <div style="flex-basis: 120px; color: var(--tdo-primary);" data-cy="items-needed-recipient-name">{{getName(row)}}</div>
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column [rowTemplate]="dateSent" propertyName="DeliveredOn" displayName="Date Sent">
              <ng-template #dateSent let-row>
                <div style="display: flex;" data-cy="items-needed-datesent-cell">
                  <div style="flex-basis: 100px;" data-cy="items-needed-date-value">{{getDate(row)}}</div>
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column [rowTemplate]="description" propertyName="Description" displayName="Description">
              <ng-template #description let-row>
                <div style="display: flex; flex: 1;" data-cy="items-needed-description-cell">
                  <div style="" data-cy="items-needed-description-value">{{row.model.Description}}</div>
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column [rowTemplate]="deliveryMethod" propertyName="enumLetterDeliveryMethodID" displayName="Delivery Method">
              <ng-template #deliveryMethod let-row>
                <div style="display: flex;" data-cy="items-needed-delivery-method-cell">
                  <div style="flex-basis: 100px;" data-cy="items-needed-delivery-method-value">{{getDeliveryMethod(row)}}</div>
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column [rowTemplate]="controls" propertyName="xauditDeleted" displayName="">
              <ng-template #controls let-row>
                <div style="display: flex;" data-cy="items-needed-controls-cell">
                  <div matTooltip="delete" (click)="deleteNeededItem(row)" style="text-align: right; cursor: pointer; flex-basis: 20px; max-width: 20px; color: var(--tdo-secondary);" data-cy="items-needed-delete-button"><lucide-icon name="trash-2" [size]="20"></lucide-icon></div>
                </div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        }
      </div>
    </div>
    <div style="flex: 1; overflow-y: hidden; margin-bottom: 3px; background-color: var(--tdo-background); border-radius: var(--border-radius); display: flex; flex-direction: column; flex-wrap: wrap; max-width: 100%; overflow-x: auto; padding: 8px;" data-cy="items-needed-options-container">
      @for (enu of notificationNeededItemEnums; track enu) {
        <div style="height: 24px; overflow-y: hidden;" data-cy="items-needed-option-item">
          <mat-checkbox [checked]="this.enumNotificationNeededItemJSON.includes(enu.ValidValueItemId)" (change)="onNeededItemsChange(enu)" style="margin-left: 2px;" data-cy="items-needed-option-checkbox">{{enu.ItemDisplayValue}}</mat-checkbox>
        </div>
      }
    </div>
  </div>
  <!--  FOOTER-->
  <div class="section-footer" style="flex-basis: 40px; min-height: 40px;" data-cy="items-needed-footer-section">
    <div style="flex: 1; margin-right: 6px;"></div>
    <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="items-needed-cancel-button">Cancel</button>
    <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="items-needed-ok-button">Ok</button>
  </div>
</div>
</div>
